export default {
  TASK_LIST: '/api/common/season/task/list',                        // 任务列表

  SEASON_LIST: '/api/contest/training/season/my/list',              // 我参与的活动列表

  SEASON_MyLIST: '/api/v2/season/my/list',                          // 我参与的活动列表

  TASK_VALIDATE: '/api/common/task/validate',                       // 任务跳转验证

  GET_EXTRA: '/api/common/task/getExtraJson',                       // 获取

  GET_TRAD_RANK: '/api/rank/list',                                  // 获取交易排行榜

  GET_QRCODEINFO: '/api/s/getShareInfo',                            // 获取交易排行榜

  GET_UNREADCOUNT: '/api/pushMessage/unReadCount',                  // 未读消息数

  SUB_TASK_LIST: '/api/common/task/list',                           // 任务的子任务列表

  PASS_PORT: '/api/contest/passport/getPassport',                   // 准考证信息/api/passport/getPassport

  NEW_PASS_PORT: '/api/passport/getPassport',                       // 新准考证信息

  TASK_SIGN_AGREEMENT: '/api/userSign/agreement',                   //  获取任务协议

  TASK_USER_SIGN: '/api/userSign/sign',                             //  同意任务协议

  COMMON_INFO: '/api/commonInfo/commonInfo',                        //  获取信息分发详情

  BIND_USERID: '/api/commonInfo/bindUserId',                        //  用户绑定信息分发

  TASK_INFO: '/api/common/task/detail'                              //  获取任务详情
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/task-list.js